import { createApiActionTypes } from '../../helpers/actions';

export const SEARCH_QUERY = createApiActionTypes('SEARCH_QUERY');

export const SET_SEARCH_QUERY_TEXT = 'search/SET_SEARCH_QUERY_TEXT';


// WEBPACK FOOTER //
// ./src/actions/search/types.js